import { render, staticRenderFns } from "./suggestionkDialog.vue?vue&type=template&id=4ff2f01c&scoped=true&"
import script from "./suggestionkDialog.vue?vue&type=script&lang=js&"
export * from "./suggestionkDialog.vue?vue&type=script&lang=js&"
import style0 from "./suggestionkDialog.vue?vue&type=style&index=0&id=4ff2f01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2f01c",
  null
  
)

export default component.exports